import React from "react";
import { FeaturedProducts1,FeaturedProducts2,FeaturedProducts3} from './data'
import { Link } from "react-router-dom";
const Featuredproducts = () => {
  return (
    <div className="menu-right-content">
      <ul className="tabpanel-column1">
        {FeaturedProducts1.map((list) => {
          return (
            <Link to={list.path}>
              <li>
                <div>
                  <div className="circle">
                    <div className="sub-icon">{list.icon}</div>
                  </div>
                </div>
                <div className="content">
                  <h5>{list.title}</h5>
                  <p>{list.desc}</p>
                </div>
              </li>
            </Link>
          );
        })}
      </ul>
      <ul className="tabpanel-column2">
        {FeaturedProducts2.map((list) => {
          return (
            <Link to={list.path}>
              <li>
                <div>
                  <div className="circle">
                    <div className="sub-icon">{list.icon}</div>
                  </div>
                </div>
                <div className="content">
                  <h5>{list.title}</h5>
                  <p>{list.desc}</p>
                </div>
              </li>
            </Link>
          );
        })}
      </ul>
      <ul className="tabpanel-column3">
        {FeaturedProducts3.map((list) => {
          return (
            <Link to={list.path}>
              <li>
                <div>
                  <div className="circle">
                    <div className="sub-icon">{list.icon}</div>
                  </div>
                </div>
                <div className="content">
                  <h5>{list.title}</h5>
                  <p>{list.desc}</p>
                </div>
              </li>
            </Link>
          );
        })}
      </ul>
    </div>
  );
};

export default Featuredproducts;
